var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',{staticClass:"payment-condition-wrapper d-flex align-items-center"},[_c('div',{staticClass:"payment-condition-tag",class:_setup.props.classes},[_vm._t("icon"),_vm._t("content")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }